import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "keyFilled"
const KeyFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.355 3.069C13.153 1.984 14.635 1.519 15.902 2.212 16.902 2.76 18.224 3.604 19.35 4.73 20.474 5.854 21.31 7.168 21.853 8.163 22.543 9.427 22.076 10.903 20.996 11.698L15.748 15.556C14.554 16.434 12.898 16.31 11.85 15.261L11.826 15.237 9.149 17.913 7.804 16.568C7.218 17.154 7.218 18.103 7.804 18.689L8.088 18.974 7.055 20.007 5.72 18.673C5.135 19.259 5.134 20.209 5.72 20.795L5.96 21.035C5.574 21.288 5.12 21.427 4.652 21.427H2.276V19.054C2.276 18.424 2.526 17.819 2.972 17.374L8.493 11.852C7.735 10.81 7.717 9.376 8.501 8.31zM12.885 8.697C12.649 8.497 12.294 8.527 12.094 8.763 11.893 9.001 11.923 9.356 12.16 9.556 12.883 10.167 13.554 10.84 14.164 11.564 14.364 11.801 14.718 11.832 14.956 11.632S15.225 11.077 15.025 10.84Q14.047 9.677 12.885 8.697M14.46 5.305C14.21 5.122 13.856 5.177 13.674 5.428 13.49 5.68 13.547 6.033 13.798 6.215 15.215 7.245 16.46 8.49 17.49 9.906 17.673 10.158 18.026 10.213 18.277 10.031 18.527 9.848 18.582 9.496 18.4 9.244 17.302 7.733 15.972 6.404 14.46 5.304"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default KeyFilledIcon
